<template>
	<div class="order">
		<ul class="uk-grid-match" uk-grid>
			<li class="uk-width-2-5@s">
				<div>
					<div class="order__spis">
						<div class="order__subtitle">Доставка:</div>
						<label>
							<input class="uk-radio" type="radio" value="Самовывоз" v-model="delivery" name="delivery" checked>
							<div class="order__desc">
								<strong>Самовывоз</strong>
								<small>Из магазина "Вся Польза", г. Казань, ул. Спартаковская 2а</small>
							</div>
							<!--<span>Самовывоз</span>-->
						</label>

						<label>
							<input class="uk-radio" type="radio" value="Доставка по Казани" v-model="delivery" name="delivery">
							<div class="order__desc">
								<strong>Доставка по Казани</strong>
								<small>Службой доставки Достависта.ру с выбором времени доставки.</small>
							</div>
							<!--<span>Доставка по Казани</span>-->
						</label>

						<label>
							<input class="uk-radio" type="radio" value="Доставка по России" v-model="delivery" name="delivery">
							<div class="order__desc">
								<strong>Доставка по России</strong>
								<small>Транспортными компаниями СДЭК, ПЭК, почта России</small>
							</div>
							<!--<span>Доставка по России</span>-->
						</label>
					</div>

					<div class="order__spis">
						<div class="order__subtitle">Оплата:</div>
						<label>
							<input class="uk-radio" value="Наличными" type="radio" name="pay" v-model="pay" checked>
							<span>Наличными</span>
						</label>

						<label>
							<input class="uk-radio" value="Оплата картой" type="radio" v-model="pay" name="pay">
							<span>Оплата картой</span>
						</label>

					</div>
				</div>
			</li>
			<li class="uk-width-3-5@s">
				<div>
					<form @submit.prevent="sendOrder">
						<div class="order__pers uk-margin-bottom">
							<div class="order__subtitle">Персональная информация:</div>
							<input class="uk-input" :class="{ 'input--error': $v.order.name.$error }" v-model="order.name" type="text" placeholder="Имя">
							<input class="uk-input" v-model="order.phone" type="tel" placeholder="Телефон">
							<input class="uk-input" name="email" v-model="order.email" type="email" placeholder="Email">
						</div>

						<div class="order__addr uk-margin-bottom" v-if="delivery !== 'Самовывоз'">
							<div class="order__subtitle">Адрес доставки:</div>
							<div v-if="delivery !== 'Доставка по Казани'">
								<input class="uk-input" v-model="order.index" type="text" placeholder="Индекс">
								<input class="uk-input" v-model="order.city" type="text" placeholder="Город">
							</div>
							<input class="uk-input" v-model="order.address" type="text" placeholder="Улица, дом, квартира">
						</div>

						<div class="order__button">
							<button class="uk-button uk-button-primary">ОФОРМИТЬ ЗАКАЗ</button>
						</div>
					</form>
				</div>
			</li>
		</ul>
		<wait></wait>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import { required, minLength, between } from 'vuelidate/lib/validators'
  import wait from './wait'
  export default {
    name: "order",
    components: { wait },
    data() {
      return {
        delivery: 'Самовывоз',
        pay: 'Наличными',
        order: {
          name: '',
          email: '',
          phone: '',
          address: '',
          city: '',
          index: ''
        },
      }
    },
	  props: {
      total: ''
	  },
    validations: {
      order:{
        name: {
          required,
          minLength: minLength(6)
        },
      }
    },
    methods: {
      sendOrder() {
        bus.$emit('wait', true);
        let app = this;
        let fd = {
          'personal': this.order,
	        'pay': this.pay,
	        'delivery': this.delivery,
	        'total': this.total,
        };
        $.request('onSendOrder', {
          data: fd,
          success: function (data) {
            //... do something ...
            if(app.pay == 'Наличными'){
              window.location.href = "/thanks";
              //bus.$emit('cart-reload', data.cart);
            } else {
              console.log(data);
              window.location.href = data.sber;
            }
            bus.$emit('wait', false);
            //window.location.href = "/thanks";
            //bus.$emit('cart-reload', data.cart);
            //this.success(data);
          },
          error: function (err) {
            console.log(err);
            bus.$emit('wait', false);
          },
        })
        //console.log(this.order);
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/order.vue